export default {
  WheelchairAssistanceFormField__AIRCRAFT_SEAT_ASSISTANCE:
    "Need lift/transfer assistance to and from aircraft seat",
  WheelchairAssistanceFormField__GATE_ASSISTANCE: "Need wheelchair assistance",
  WheelchairAssistanceFormField__HEADER: "Wheelchair assistance",
  WheelchairAssistanceFormField__NO_WHEELCHAIR_ASSISTANCE: "No wheelchair assistance needed",
  WheelchairAssistanceFormField__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.name} option selected. ${data.index} of ${data.length}`,
};
